import React from 'react';

import { IonRefresher, IonRefresherContent } from '@ionic/react';

import Spinner from '../Spinner';
import './PageRefresher.scss';
import { PageRefresherProps } from './types';

const PageRefresher: React.FC<PageRefresherProps> = ({ callback }) => {
  return (
    <IonRefresher slot="fixed" onIonRefresh={callback}>
      <IonRefresherContent refreshingSpinner={null}>
        <div className="page-refresher">
          <Spinner color='primary' />
        </div>
      </IonRefresherContent>
    </IonRefresher>
  );
};

export default React.memo(PageRefresher);
